import React from 'react'

export default function DistopikMidSide() {
    return 'mid/side'
}